import { useDispatch, useSelector } from 'react-redux';

import { actions, customActions_organism } from '@redux/actions';

//____________________ ORGANISM	____________________

//currencyBoard
export const useOrganism_currencyBoard = () => {
	const currencyBoard = useSelector((state) => state.organism.currencyBoard);
	const dispatch = useDispatch();

	return {
		state: currencyBoard,
		actions: customActions_organism.currencyBoard,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.organism_currencyBoard_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.organism_currencyBoard_clear(values, scope)),
	};
};

//eventSlider
export const useOrganism_eventSlider = () => {
	const eventSlider = useSelector((state) => state.organism.eventSlider);
	const dispatch = useDispatch();

	return {
		state: eventSlider,
		actions: customActions_organism.eventSlider,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.organism_eventSlider_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.organism_eventSlider_clear(values, scope)),
	};
};

//currencyConverter
export const useOrganism_currencyConverter = () => {
	const currencyConverter = useSelector((state) => state.organism.currencyConverter);
	const dispatch = useDispatch();

	return {
		state: currencyConverter,
		actions: customActions_organism.currencyConverter,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.organism_currencyConverter_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.organism_currencyConverter_clear(values, scope)),
	};
};

//login
export const useOrganism_login = () => {
	const login = useSelector((state) => state.organism.login);
	const dispatch = useDispatch();

	return {
		state: login,
		actions: customActions_organism.login,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.organism_login_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.organism_login_clear(values, scope)),
	};
};

//mainBoard
export const useOrganism_mainBoard = () => {
	const mainBoard = useSelector((state) => state.organism.mainBoard);
	const dispatch = useDispatch();

	return {
		state: mainBoard,
		actions: customActions_organism.mainBoard,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.organism_mainBoard_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.organism_mainBoard_clear(values, scope)),
	};
};

//productManage
export const useOrganism_productManage = () => {
	const productManage = useSelector((state) => state.organism.productManage);
	const dispatch = useDispatch();

	return {
		state: productManage,
		actions: customActions_organism.productManage,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.organism_productManage_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.organism_productManage_clear(values, scope)),
	};
};

//register
export const useOrganism_register = () => {
	const register = useSelector((state) => state.organism.register);
	const dispatch = useDispatch();

	return {
		state: register,
		actions: customActions_organism.register,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.organism_register_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.organism_register_clear(values, scope)),
	};
};

//surveyManage
export const useOrganism_surveyManage = () => {
	const surveyManage = useSelector((state) => state.organism.surveyManage);
	const dispatch = useDispatch();

	return {
		state: surveyManage,
		actions: customActions_organism.surveyManage,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.organism_surveyManage_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.organism_surveyManage_clear(values, scope)),
	};
};

//worldClock
export const useOrganism_worldClock = () => {
	const worldClock = useSelector((state) => state.organism.worldClock);
	const dispatch = useDispatch();

	return {
		state: worldClock,
		actions: customActions_organism.worldClock,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.organism_worldClock_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.organism_worldClock_clear(values, scope)),
	};
};

//news
export const useOrganism_news = () => {
	const news = useSelector((state) => state.organism.news);
	const dispatch = useDispatch();

	return {
		state: news,
		actions: customActions_organism.news,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.organism_news_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.organism_news_clear(values, scope)),
	};
};
